import React, { createContext, useState, useEffect } from 'react';
import CustomAlert from '../customAlert';

export const CartContext = createContext();

export function CartProvider({ children }) {
  const initialCart = JSON.parse(localStorage.getItem('vp-portal-cart')) || [];
  const [cartItems, setCartItems] = useState(initialCart);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    localStorage.setItem('vp-portal-cart', JSON.stringify(cartItems));
  }, [cartItems]);

  const addToCart = (product) => {
    const productType = product.attributes?.type || 'product'; // Identifiser type, default til 'product' hvis ikke satt
    const productId = product.id || product.data.id; // Hent riktig ID
    const combinedId = `${productType}-${productId}`; // Kombiner type og ID

    const existingItem = cartItems.find((item) => item.combinedId === combinedId);

    if (existingItem) {
      const updatedItems = cartItems.map((item) => {
        if (item.combinedId === combinedId) {
          return { ...item, quantity: item.quantity + 1 };
        }
        return item;
      });
      setCartItems(updatedItems);
      setAlertMessage('Lagt til i din handlekurv!');
      setIsError(false);
      setShowAlert(true);
    } else {
      setCartItems([...cartItems, { ...product, quantity: 1, combinedId }]);
      setAlertMessage('Lagt til i din handlekurv!');
      setIsError(false);
      setShowAlert(true);
    }
  };

  const removeFromCart = (combinedId) => {
    setCartItems(cartItems.filter((item) => item.combinedId !== combinedId));
  };

  const clearCart = () => {
    setCartItems([]);
    // setAlertMessage('Din handlekurv er slettet!');
    // setIsError(false);
    // setShowAlert(true);
  };

  const increaseQuantity = (combinedId) => {
    const updatedItems = cartItems.map((item) => {
      if (item.combinedId === combinedId) {
        return { ...item, quantity: item.quantity + 1 };
      }
      return item;
    });
    setCartItems(updatedItems);
  };

  const decreaseQuantity = (combinedId) => {
    const updatedItems = cartItems.map((item) => {
      if (item.combinedId === combinedId && item.quantity > 1) {
        return { ...item, quantity: item.quantity - 1 };
      }
      return item;
    });
    setCartItems(updatedItems);
  };

  const handleAlertClose = () => {
    setShowAlert(false);
  };

  return (
    <CartContext.Provider value={{ cartItems, addToCart, removeFromCart, clearCart, increaseQuantity, decreaseQuantity }}>
      {children}
      <CustomAlert
        show={showAlert}
        handleClose={handleAlertClose}
        message={alertMessage}
        isError={isError}
        buttonLabel="OK"
        buttonClassName="ok-knapp"
      />
    </CartContext.Provider>
  );
}

export default CartProvider;





